import { render, staticRenderFns } from "./CombinedFormReportChart.vue?vue&type=template&id=664fc242"
import script from "./CombinedFormReportChart.vue?vue&type=script&lang=js"
export * from "./CombinedFormReportChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('664fc242')) {
      api.createRecord('664fc242', component.options)
    } else {
      api.reload('664fc242', component.options)
    }
    module.hot.accept("./CombinedFormReportChart.vue?vue&type=template&id=664fc242", function () {
      api.rerender('664fc242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/CombinedFormReportChart.vue"
export default component.exports